import { imageModels } from './index';
import { buildProviderOptions } from './ui-options';

/**
 * 与画布生成请求一致：modelUi → buildProviderOptions，再合并 file_url、image_resolution（命中模型 resolutions 时）。
 * 扣费与预估应使用同一套 providerOptions，getCost 等只读根级字段即可。
 */
export function buildImageProviderOptionsForRequest(params: {
  modelId: string;
  modelUi: Record<string, any>;
  image_resolution?: string | null;
}): Record<string, any> {
  const { modelId, modelUi, image_resolution } = params;
  const providerOptions: Record<string, any> = {
    ...(buildProviderOptions(modelId, modelUi) as unknown as Record<string, any>),
  };
  if (typeof modelUi?.file_url === 'string' && modelUi.file_url) {
    providerOptions.file_url = modelUi.file_url;
  }
  try {
    const res = typeof image_resolution === 'string' ? image_resolution.trim() : '';
    // 白名单 = 顶层 resolutions ∪ configByMode 各模式的 resolutions（有的模型只配了 configByMode）
    const model = (imageModels as any)?.[modelId];
    const allowedList: string[] = [
      ...(Array.isArray(model?.resolutions) ? model.resolutions : []),
      ...Object.values(model?.configByMode ?? {}).flatMap((m: any) =>
        Array.isArray(m?.resolutions) ? m.resolutions : []
      ),
    ].map(String);
    if (
      res &&
      res !== 'Auto' &&
      allowedList.length > 0 &&
      allowedList.includes(res)
    ) {
      providerOptions.image_resolution = res;
    }
  } catch {
    /* ignore */
  }
  return providerOptions;
}
